import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader";
import "./vendorquote.css";
import Table from "../../constants/Table";

const VendorQuotationForm = () => {
  const { state } = useLocation();
  const rfq = state?.rfq || {};
  console.log(rfq,"rfq")
  const navigate = useNavigate();
const isEditMode = Boolean(rfq?.quotation?.id);

  const [items, setItems] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [docErrors, setDocErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  /* -------------------- PRODUCTS -------------------- */
  useEffect(() => {
    if (Array.isArray(rfq.products)) {
      const combined = rfq.products.map((p) => ({
        item: p.item || "",
        quantity: Number(p.quantity || 0),
        unitPrice: Number(p.price || 0),
        total: Number(p.quantity || 0) * Number(p.price || 0),
        product_id: p.product_id?.toString() || "",
        rfq_product_link_id: p.id,
      }));
      setItems(combined);
    }
  }, [rfq]);

  /* -------------------- DOCUMENTS -------------------- */
useEffect(() => {
  if (!Array.isArray(rfq?.rfq_documents)) return;

  const docs = rfq.rfq_documents.map((doc) => ({
    id: doc.rfq_param_id,
    name: doc.name,
    file: null,
    preview: null,
    uploaded: doc.uploaded_documents || [], // already uploaded docs
  }));

  setDocuments(docs);
}, [rfq]);


  /* -------------------- FILE HANDLERS -------------------- */
  const handleFileChange = (index, file) => {
    const updated = [...documents];
    updated[index] = { ...updated[index], file, preview: URL.createObjectURL(file) };
    setDocuments(updated);

    // Clear error for this document
    setDocErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[index];
      return updatedErrors;
    });
  };

  const handleRemoveFile = (index) => {
    const updated = [...documents];
    updated[index] = { ...updated[index], file: null, preview: null };
    setDocuments(updated);
  };

const handleRemoveUploadedFile = (docIndex, uploadedIndex) => {
  const updatedDocs = [...documents];

  updatedDocs[docIndex].uploaded = updatedDocs[docIndex].uploaded.filter(
    (_, i) => i !== uploadedIndex
  );

  setDocuments(updatedDocs);
};

  /* -------------------- VALIDATION -------------------- */
  const validationSchema = Yup.object({
    items: Yup.array().of(
      Yup.object({
        unitPrice: Yup.number().required("Please enter the unitPrice").min(1),
      })
    ),
    deliveryValidity: Yup.number()
      .required("Quotation Validity is required")
      .min(1),
    deliveryTime: Yup.string().required("Delivery Time is required"),
    paymentTerms: Yup.string().required("PaymentTerms is required"),
  });

  /* -------------------- FORMIK -------------------- */
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
  items,
  deliveryValidity: rfq.quotation?.quotation_validity || "",
  deliveryTime: rfq.quotation?.delivery_time || "",
  paymentTerms: rfq.quotation?.payment_terms || "",
  additionalInfo: rfq.quotation?.additional_info || "",
},

    validationSchema,
    onSubmit: async (values) => {
      // Check document errors individually
      const errors = {};
      documents.forEach((doc, index) => {
  const hasOld = doc.uploaded?.length > 0;
  const hasNew = doc.file;

  if (!hasOld && !hasNew) {
    errors[index] = true;
  }
});

      if (Object.keys(errors).length > 0) {
        setDocErrors(errors);
        toast.error("Please upload all required documents");
        return;
      }
      setDocErrors({});

      try {
        setLoading(true);

        const documentsPayload = await Promise.all(
  documents.map(async (doc) => {
    let newFileData = null;

    // If user uploaded new file
    if (doc.file) {
      newFileData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(doc.file);
      });
    }

    return {
      rfq_param_id: doc.id,
      name: doc.name,
      file: newFileData,                 
      existing_files: doc.uploaded || []
    };
  })
);


        const payload = {
          id: rfq.rfq_id,
          quotation_id: rfq.quotation?.id || null,
          is_update: isEditMode,  
          supplier_id: userDetails?.id,
          product_id: values.items.map((i) => i.product_id),
          total_price: values.items.map((i) => Number(i.unitPrice)),
          rfq_product_link_id: values.items.map((i) => i.rfq_product_link_id),
          delivery_time: values.deliveryTime,
          quotation_validity: values.deliveryValidity,
          payment_terms: values.paymentTerms,
          additional_info: values.additionalInfo,
          documents: documentsPayload,
        };

        const res = await apicall.post(payload, "quotation");

        if (res.success) {
          toast.success(res.message);
          navigate(-1);
        } else {
          toast.error(res.message || "Submission failed");
        }
      } catch {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  /* -------------------- ITEM CHANGE -------------------- */
  const handleItemChange = (index, value) => {
    const updated = [...formik.values.items];
    updated[index].unitPrice = Number(value || 0);
    updated[index].total = updated[index].quantity * updated[index].unitPrice;
    formik.setFieldValue("items", updated);
  };

  /* -------------------- TABLE -------------------- */
  const headers = ["Item", "Quantity", "Unit Price ($)", "Total Price ($)"];
  const tableData = formik.values.items.map((row, index) => [
    row.item,
    row.quantity,
    <input
      key={index}
      type="number"
      className="form-control input-price text-center"
      value={row.unitPrice}
      onChange={(e) => handleItemChange(index, e.target.value)}
    />,
    <span className="fw-semibold text-success">${row.total.toFixed(2)}</span>,
  ]);

  const totalAmount = formik.values.items.reduce((sum, i) => sum + Number(i.total || 0), 0);

  /* -------------------- UI -------------------- */
  return (
    <div className="container-fluid p-4">
      <form onSubmit={formik.handleSubmit} className="quotation-form">
        <div className="back-link" onClick={() => navigate(-1)}>
          <FaArrowLeft className="me-2" /> Back to RFQ
        </div>

        {/* RFQ Info */}
        <div className="section-card">
          <h5>
            Quotation for RFQ: {rfq.display_rfq_id && `${rfq.display_rfq_id}`}
          </h5>
          <p className="text-muted mb-1">{rfq.title} — {rfq.company_info?.name}</p>
          <span className="deadline">Deadline: {new Date(rfq.responsible_date).toDateString()}</span>
        </div>

        {/* Item Pricing */}
        <div className="section-card">
          <h6 className="section-title">Item Pricing</h6>
          <Table headers={headers} data={tableData} pagination={false} recordsCount={tableData.length} />
          <div className="text-end mt-3">
            Total Amount: <span className="text-success">${totalAmount.toFixed(2)}</span>
          </div>
        </div>

        {/* Delivery Details */}
        <div className="section-card">
          <h6 className="section-title">Delivery Details</h6>
          <div className="row g-3">
            <div className="col-md-4">
              <label>Quotation Validity (days)</label>
              <input
                type="number"
                className="form-control"
                placeholder="30"
                value={formik.values.deliveryValidity}
                onChange={(e) => formik.setFieldValue("deliveryValidity", e.target.value)}
              />
              {formik.touched.deliveryValidity && formik.errors.deliveryValidity && (
                <div className="invalid-feedback d-block mt-1">{formik.errors.deliveryValidity}</div>
              )}
            </div>
            <div className="col-md-4">
              <label>Delivery Time</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g., 2–3 weeks"
                value={formik.values.deliveryTime}
                onChange={(e) => formik.setFieldValue("deliveryTime", e.target.value)}
              />
              {formik.touched.deliveryTime && formik.errors.deliveryTime && (
                <div className="invalid-feedback d-block mt-1">{formik.errors.deliveryTime}</div>
              )}
            </div>
            <div className="col-md-4">
              <label>Payment Terms</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g., 30% advance, 70% on delivery"
                value={formik.values.paymentTerms}
                onChange={(e) => formik.setFieldValue("paymentTerms", e.target.value)}
              />
              {formik.touched.paymentTerms && formik.errors.paymentTerms && (
                <div className="invalid-feedback d-block mt-1">{formik.errors.paymentTerms}</div>
              )}
            </div>
          </div>
        </div>

       {/* Documents */}
{documents.length > 0 && (
  <div className="section-card">
    <h6 className="section-title">Documents</h6>
    {documents.map((doc, i) => (
  <div key={i} className="mb-3">

    {/* Top Row */}
    <div className="doc-row d-flex align-items-center gap-3">
      <span className="fw-semibold" style={{ minWidth: "150px" }}>
        {doc.name}
      </span>

      <label className="btn-upload mb-0">
        Choose File
        <input
          type="file"
          onChange={(e) => {
            const file = e.target.files[0];
            handleFileChange(i, file);
            e.target.value = "";
          }}
        />
      </label>

      {doc.file && (
        <span className="text-truncate small" style={{ maxWidth: "200px" }}>
          {doc.file.name}
        </span>
      )}
    </div>

    {/* Previously Uploaded Preview (SEPARATE BLOCK) */}
    {doc.uploaded?.length > 0 && (
      <div className="row g-3 mt-2">
        {doc.uploaded.map((u, idx) => {
          if (!u.document) return null;

          const fileUrl = u.document;
          const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);
          const isPdf = /\.pdf$/i.test(fileUrl);

          return (
            <div key={idx} className="col-md-4">
  <div className="border rounded p-2 position-relative">

    <button
      type="button"
      className="btn btn-sm btn-danger position-absolute"
      style={{ top: "6px", right: "6px", zIndex: 2 }}
      onClick={() => handleRemoveUploadedFile(i, idx)}
    >
      ❌
    </button>

    {isImage && (
      <img
        src={fileUrl}
        alt="uploaded-preview"
        className="img-fluid rounded"
        style={{
          width: "100%",
          height: "150px",
          objectFit: "cover",
          border: "1px solid #ddd"
        }}
      />
    )}

    {isPdf && (
      <iframe
        src={fileUrl}
        title="pdf-preview"
        style={{
          width: "100%",
          height: "150px",
          border: "1px solid #ddd"
        }}
      />
    )}

    {!isImage && !isPdf && (
      <div className="small text-muted">
        📎 {fileUrl.split("/").pop()}
      </div>
    )}
  </div>
</div>

          );
        })}
      </div>
    )}

  </div>
))}


    {/* Uploaded Previews */}
    {documents.some((d) => d.file) && (
      <div className="row g-3 mt-2">
        {documents.map(
          (doc, i) =>
            doc.file && (
              <div key={i} className="col-md-4">
                <div className="border rounded p-2 h-100 position-relative">
                  <button
                    type="button"
                    className="btn btn-sm btn-danger position-absolute"
                    style={{ top: "8px", right: "8px" }}
                    onClick={() => handleRemoveFile(i)}
                  >
                    ❌
                  </button>

                  {doc.file.type.startsWith("image/") && (
                    <img src={doc.preview} alt="preview" className="img-fluid rounded" 
                                          style={{ width: "100%", height: "150px", border: "1px solid #ddd" }}

                    />
                  )}

                  {doc.file.type === "application/pdf" && (
                    <iframe
                      src={doc.preview}
                      title="pdf-preview"
                      style={{ width: "100%", height: "100px", border: "1px solid #ddd" }}
                    />
                  )}

                  {!doc.file.type.startsWith("image/") &&
                    doc.file.type !== "application/pdf" && (
                      <div className="small text-muted">📎 {doc.file.name}</div>
                    )}
                </div>
              </div>
            )
        )}
      </div>
    )}
  </div>
)}


        {/* Total & Submit */}
        <div className="section-card d-flex justify-content-between align-items-center mt-3">
          <h5 className="text-success">Total Quotation Amount: ${totalAmount.toFixed(2)}</h5>
          <button className="btn-submit" disabled={loading}>
            {loading ? <Loader /> : isEditMode ? "Update Quotation" : "Send Quotation"}

          </button>
        </div>
      </form>
    </div>
  );
};

export default VendorQuotationForm;
